import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-amber-50 py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-237" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-238" data-mp="j7yex2vfcf1u">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-green-950 sm:text-4xl" data-id="element-239" data-mp="j53uvcgbow8y">
          Everything included
        </h2>
        <p className="mt-3 text-center text-stone-600" data-id="element-240" data-mp="1bvks92ugey1w">
          {productShortName} · {totalVolumes} volumes + {totalBonuses} bonuses ·{' '}
          <b className="text-green-900" data-id="element-241" data-mp="16yuckgmka4h0">{price}</b>
        </p>

        <ul className="mt-10 grid overflow-hidden rounded-xl border border-stone-200 bg-white sm:grid-cols-2" data-id="element-242" data-mp="12u4i8w7jwxy7">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 border-b border-stone-100 p-4 sm:odd:border-r" data-id="element-243" data-mp="3nln3cneyh1yd">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-900" data-id="element-244" data-mp="3id5xjwi9h5gv">
                <CheckIcon className="h-3.5 w-3.5 text-amber-400" aria-hidden="true" data-id="element-245" data-mp="3nc91teqf37ns" />
              </span>
              <p data-id="element-246" data-mp="39b6dswfv3na8">
                <b className="block text-sm text-green-950" data-id="element-247" data-mp="39boj0iki5bua">{feature}</b>
                <span className="text-sm text-stone-600" data-id="element-248" data-mp="3dd1ogrjond0o">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-stone-500 bg-stone-100 px-6 py-5 text-center text-lg font-bold leading-relaxed text-stone-700" data-id="element-249" data-mp="2zktxxhizsiaf">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}